const pad2 = (value) => String(value).padStart(2, "0");

/** Default newsletter name: senza-nome-{gg/mm/aa}. */
export const createDefaultNewsletterName = (date = new Date()) => {
  const day = pad2(date.getDate());
  const month = pad2(date.getMonth() + 1);
  const year = pad2(date.getFullYear() % 100);
  return `senza-nome-${day}/${month}/${year}`;
};

export const resolveNewsletterDisplayName = (name) => {
  const trimmed = (name || "").trim();
  if (!trimmed || trimmed === "Nuova newsletter") {
    return createDefaultNewsletterName();
  }
  return trimmed;
};

export const resolveNewsletterSaveName = (name) => resolveNewsletterDisplayName(name);
 